module.exports = __webpack_public_path__ + "static/media/ehealth_website_banner_desktop.bf5bd270.jpg";